__turbopack_context__.v({
  "contentWrapper": "TherapySection-module__R2iD9W__contentWrapper",
  "description": "TherapySection-module__R2iD9W__description",
  "divider": "TherapySection-module__R2iD9W__divider",
  "featureDescription": "TherapySection-module__R2iD9W__featureDescription",
  "featureItem": "TherapySection-module__R2iD9W__featureItem",
  "featureList": "TherapySection-module__R2iD9W__featureList",
  "featureTitle": "TherapySection-module__R2iD9W__featureTitle",
  "header": "TherapySection-module__R2iD9W__header",
  "heading": "TherapySection-module__R2iD9W__heading",
  "leftColumn": "TherapySection-module__R2iD9W__leftColumn",
  "rightColumn": "TherapySection-module__R2iD9W__rightColumn",
  "section": "TherapySection-module__R2iD9W__section",
  "therapyVideo": "TherapySection-module__R2iD9W__therapyVideo",
  "videoFrame": "TherapySection-module__R2iD9W__videoFrame",
});
